const LABELS = {
    sq: {
        form: {
            title: 'Kërkimi i Biznesit',
            subtitle: 'Plotësoni fushat për të filtruar rezultatet',
            resetTooltip: 'Pastro formularin',
            advancedToggle: 'Kërkim i avancuar',
            submit: 'KËRKO',
            emriBiznesit: 'Emri',
            emriBiznesitPlaceholder: 'Emri i biznesit ose emri tregtar',
            nui: 'NUI',
            nuiPlaceholder: 'Numri unik identifikues ose numri i biznesit',
            nrPersonal: 'ID e pronarit / të autorizuarit / bordit',
            komuna: 'Komuna',
            sektori: 'Sektori',
            aktivitetiKryesor: 'Aktiviteti kryesor',
            numriFiskal: 'Numri fiskal',
            aktivitetetTjera: 'Aktivitetet tjera',
            ndryshimiTipit: 'Ndryshimi i formës së biznesit',
            formaBiznesit: 'Forma e biznesit',
            pronesia: 'Pronësia',
            pronesiaLegend: 'Kërkimi sipas të dhënave të pronësisë',
            perqindjaHuaj: 'Përqindja e pronësisë së huaj',
            shteti: 'Shteti',
            komunaPronarit: 'Komuna e pronarit',
            emerPronari: 'Emri i pronarit / pronarit juridik / përfaqësuesit / bordit',
            mbiemriPronarit: 'Mbiemri i pronarit / pronarit juridik / përfaqësuesit / bordit',
            statusi: 'Statusi i biznesit',
            numriNjesise: 'Numri i njësisë',
            numriNjesiveTeRegjistruara: 'Numri i njësive të regjistruara',
            emriVjeter: 'Emri i vjetër i biznesit',
            emriVjeterPlaceholder: 'Emri i mëparshëm i biznesit',
            email: 'Email',
            emailPlaceholder: 'Email i biznesit',
            telefoni: 'Telefoni',
            telefoniPlaceholder: 'Numri i telefonit',
            adresa: 'Adresa / rruga',
            adresaPlaceholder: 'Adresa ose rruga',
            vitiThemelimit: 'Viti i themelimit',
            vitiShuarjes: 'Viti i shuarjes',
            vitiNdryshimit: 'Viti i ndryshimit të fundit',
            yearPlaceholder: 'Zgjedh vitin...',
            kontaktiLegend: 'Kërkimi sipas të dhënave të kontaktit dhe adresës',
            pronariLegend: 'Kërkimi sipas të dhënave të pronarëve, drejtorëve, të autorizuarve, anëtarëve të bordit',
            numriPuntoreve: 'Numri i punëtorëve',
            numriPuntorevePlaceholder: 'Numri i punëtorëve',
            institucioni: 'Institucioni',
            institucioniPlaceholder: 'Zgjedh institucionin',
            vitetLegend: 'Kërkimi sipas të dhënave të vitit',
            teDhenatShteseLegend: 'Kërkimi sipas të dhënave shtesë të biznesit',
            selectPlaceholder: 'Zgjedh...',
            validationError: 'Ju lutem plotësoni të paktën një fushë',
            networkError: 'Gabim në rrjet ose server. Provoni përsëri.',
            verificationLoading: 'Verifikimi po ngarkohet. Provoni përsëri.',
            verificationFailed: 'Verifikimi dështoi. Provoni përsëri.',
            verificationRetry: 'Provo përsëri',
            tooManyRequests: 'Keni bërë shumë kërkime. Provoni më vonë.',
            detailsDailyLimit:
                'Keni arritur numrin maksimal të bizneseve që mund të shikoni brenda 24 orëve. Provoni përsëri më vonë.',
            detailsTooManyRequests: 'Keni hapur shumë biznese brenda një kohe të shkurtër. Provoni përsëri pas një minute.',
            detailsExpired: 'Rezultatet e kërkimit kanë skaduar. Ju lutem kërkoni përsëri.',
            detailsNoneSelected: 'Nuk është zgjedhur asnjë biznes. Ju lutem bëni një kërkim.',
            minLengthError: 'Kriteret e kërkimit duhet të kenë së paku 3 karaktere.',
            resultsTruncated:
                'Kërkimi ka shumë rezultate. Po shfaqen {kufizuar} nga {gjithsej} — ngushtoni kriteret e kërkimit.',
        },
        results: {
            sectionTitle: 'Rezultatet e Bizneseve',
            countBanner: (shown, total) => `Në listën në vijim janë paraqitur ${shown} nga ${total} rezultate në kërkimin tuaj.`,
            refineHint: 'Për të marrë rezultate më specifike, ju lutem vendosni kritere shtesë në kërkim.',
            empty: 'Nuk u gjet asnjë biznes për kriteret e dhëna.',
            columns: {
                emri: 'Emri',
                emriTregtar: 'Emri tregtar',
                nui: 'NUI',
                komuna: 'Komuna',
                llojiBiznesit: 'Lloji biznesit',
                statusi: 'Statusi',
                njesite: 'Njësitë',
            },
            ndryshimiTipit: 'Ndryshimi i formës së biznesit',
            groupOwners: 'Pronarët',
            groupReps: 'Përfaqësuesit',
            groupBordi: 'Bordi',
            groupContact: 'Kontakti',
            email: 'Email',
            sektori: 'Sektori',
            numriPuntoreve: 'Numri i punëtorëve',
            noOwners: 'Nuk ka pronarë të regjistruar.',
            noReps: 'Nuk ka përfaqësues të regjistruar.',
            noBordi: 'Nuk ka bord të regjistruar.',
            ownerLegal: 'Pronar Juridik',
            ownerPhysical: 'Pronar Fizik',
            showMorePersons: (n) => `+${n} të tjerë`,
            showLessPersons: 'Më pak',
            statusLabel: 'Statusi',
            units: (n) => `${n} njësi`,
            sortLabel: 'Rendit sipas',
            sortRelevance: 'Përputhja më e mirë',
            established: 'Themeluar',
            passive: 'Pasivizuar',
            closed: 'Shuar',
            rowDetails: 'Shih detajet e biznesit',
        },
        atk: {
            tab: 'Informacione nga ATK',
            title: 'Informacione nga ATK',
            subtitle: 'Administrata Tatimore e Kosovës',
            empty: 'Të dhënat nga ATK nuk janë të disponueshme.',
            loading: 'Duke ngarkuar të dhënat nga ATK...',
            error: 'Të dhënat nga ATK nuk u morën. Provoni përsëri.',
            retry: 'Provo përsëri',
            tatimpaguesi: 'Të dhënat e tatimpaguesit',
            nui: 'NUI',
            emri: 'Emri',
            numriPunetoreve: 'Numri punëtorëve',
            numriPunetorevePershkrim: 'Numri punëtorëve të raportuar në deklaratën e fundit në ATK',
            statusi: 'Statusi',
            dataStatusit: 'Data e statusit',
            adresaTitulli: 'Të dhënat e adresës',
            adresa: 'Adresa',
            telefoni: 'Telefoni',
            email: 'E-mail',
            kontabilisti: 'Të dhënat e kontabilistit',
            emriKontabilistit: 'Emri',
            llogariaBankare: 'Të dhënat e llogarisë bankare',
            banka: 'Banka',
            numriLlogarise: 'Numri i llogarisë',
            paPelqim: 'Nuk është dhënë pëlqimi nga tatim paguesi për shfaqjen e këtyre të dhënave!',
            burimi: 'Burimi: Administrata Tatimore e Kosovës (ATK).',
            pasqyratTitulli: 'Pasqyrat financiare',
            pasqyratPershkrim: 'Zgjidhni vitin dhe formularin për të marrë pasqyrën financiare të deklaruar në ATK.',
            viti: 'Viti',
            formulari: 'Formulari',
            kerko: 'Kërko',
            shkarko: 'Shkarko Excel',
            pasqyraBosh: 'Nuk ka pasqyrë financiare të deklaruar për vitin dhe formularin e zgjedhur.',
            pasqyraGabim: 'Pasqyra financiare nuk u mor nga ATK. Provoni përsëri.',
            sesioniSkadoi: 'Sesioni ka skaduar. Rifreskoni faqen dhe provoni përsëri.',
            shumeKerkesa: 'Keni bërë shumë kërkesa. Provoni më vonë.',
            formularet: {
                Fs100: 'Pasqyra e pozitës financiare më 31 dhjetor',
                Fs110: 'Pasqyra e të ardhurave gjithëpërfshirëse për vitin që përfundon më 31 dhjetor',
                Fs120: 'Pasqyra e ndryshimeve në ekuitet/kapital për vitin që përfundon më 31 dhjetor',
                Fs130: 'Pasqyra e rrjedhjes së parasë për vitin që përfundon më 31 dhjetor',
                Fs150: 'Pasqyra e konsoliduar e pozitës financiare më 31 dhjetor',
                Fs160: 'Pasqyra e konsoliduar e të ardhurave gjithëpërfshirëse dhe fitimit të mbajtur',
                Fs170: 'Pasqyra e konsoliduar e ndryshimeve në ekuitet',
                Fs180: 'Pasqyra e konsoliduar e rrjedhjes së parasë',
            },
        },
    },
    en: {
        form: {
            title: 'Business Search',
            subtitle: 'Fill in fields to filter results',
            resetTooltip: 'Reset search form',
            advancedToggle: 'Advanced search',
            submit: 'SEARCH',
            emriBiznesit: 'Name',
            emriBiznesitPlaceholder: 'Business name or trade name',
            nui: 'UIN',
            nuiPlaceholder: 'Unique Identification Number or business number',
            nrPersonal: 'Owner`s / Authorizer`s / Board ID',
            komuna: 'Municipality',
            sektori: 'Sector',
            aktivitetiKryesor: 'Main Activity',
            numriFiskal: 'Fiscal Number',
            aktivitetetTjera: 'Other Activities',
            ndryshimiTipit: 'Change of business form',
            formaBiznesit: 'Business Form',
            pronesia: 'Ownership',
            pronesiaLegend: 'Search by ownership data',
            perqindjaHuaj: 'Foreign ownership percentage',
            shteti: 'State',
            komunaPronarit: 'Municipality of the Owner',
            emerPronari: 'Name of owner / legal owner / representative / board',
            mbiemriPronarit: 'Surname of owner / legal owner / representative / board',
            statusi: 'Business Status',
            numriNjesise: 'Unit Number',
            numriNjesiveTeRegjistruara: 'Number of Registered Units',
            emriVjeter: 'Old Business Name',
            emriVjeterPlaceholder: 'Previous business name',
            email: 'Email',
            emailPlaceholder: 'Business email',
            telefoni: 'Phone',
            telefoniPlaceholder: 'Phone number',
            adresa: 'Address / Street',
            adresaPlaceholder: 'Address or street',
            vitiThemelimit: 'Year of Establishment',
            vitiShuarjes: 'Year of Closure',
            vitiNdryshimit: 'Year of last change',
            yearPlaceholder: 'Select year...',
            kontaktiLegend: 'Search by contact and address data',
            pronariLegend: 'Search by owner, director, authorized person and board member data',
            numriPuntoreve: 'Number of employees',
            numriPuntorevePlaceholder: 'Number of employees',
            institucioni: 'Institution',
            institucioniPlaceholder: 'Select institution',
            vitetLegend: 'Search by year data',
            teDhenatShteseLegend: 'Search by additional business data',
            selectPlaceholder: 'Select...',
            validationError: 'Please fill in at least one field',
            networkError: 'Network or server error. Please try again.',
            verificationLoading: 'Verification is loading. Please try again.',
            verificationFailed: 'Verification failed. Please try again.',
            verificationRetry: 'Try again',
            tooManyRequests: 'Too many searches. Please try again later.',
            detailsDailyLimit:
                'You have reached the maximum number of businesses you can view within 24 hours. Please try again later.',
            detailsTooManyRequests: 'You have opened too many businesses in a short time. Please try again in a minute.',
            detailsExpired: 'The search results have expired. Please search again.',
            detailsNoneSelected: 'No business selected. Please run a search.',
            minLengthError: 'Search criteria must be at least 3 characters long.',
            resultsTruncated:
                'The search has too many results. Showing {kufizuar} of {gjithsej} — please narrow your criteria.',
        },
        results: {
            sectionTitle: 'Business Results',
            countBanner: (shown, total) => `The list below shows ${shown} of ${total} results for your search.`,
            refineHint: 'To get more specific results, please add extra search criteria.',
            empty: 'No business was found for the given criteria.',
            columns: {
                emri: 'Name',
                emriTregtar: 'Trade Name',
                nui: 'UIN',
                komuna: 'Municipality',
                llojiBiznesit: 'Business type',
                statusi: 'Status',
                njesite: 'Units',
            },
            ndryshimiTipit: 'Business form change',
            groupOwners: 'Owners',
            groupReps: 'Representatives',
            groupBordi: 'Board',
            groupContact: 'Contact',
            email: 'Email',
            sektori: 'Sector',
            numriPuntoreve: 'Number of employees',
            noOwners: 'No registered owners.',
            noReps: 'No registered representatives.',
            noBordi: 'No registered board members.',
            ownerLegal: 'Legal Owner',
            ownerPhysical: 'Individual Owner',
            showMorePersons: (n) => `+${n} more`,
            showLessPersons: 'Show less',
            statusLabel: 'Status',
            units: (n) => `${n} ${n === 1 ? 'unit' : 'units'}`,
            sortLabel: 'Sort by',
            sortRelevance: 'Best match',
            established: 'Established',
            passive: 'Passivated',
            closed: 'Closed',
            rowDetails: 'View business details',
        },
        atk: {
            tab: 'TAK information',
            title: 'Information from TAK',
            subtitle: 'Tax Administration of Kosovo',
            empty: 'TAK data is not available.',
            loading: 'Loading data from TAK...',
            error: 'TAK data could not be loaded. Please try again.',
            retry: 'Try again',
            tatimpaguesi: 'Taxpayer data',
            nui: 'Unique identification number',
            emri: 'Name',
            numriPunetoreve: 'Number of employees',
            numriPunetorevePershkrim: 'Number of employees reported in the latest declaration to TAK',
            statusi: 'Status',
            dataStatusit: 'Status date',
            adresaTitulli: 'Address data',
            adresa: 'Address',
            telefoni: 'Phone',
            email: 'E-mail',
            kontabilisti: 'Accountant data',
            emriKontabilistit: 'Name',
            llogariaBankare: 'Bank account data',
            banka: 'Bank',
            numriLlogarise: 'Account number',
            paPelqim: 'The taxpayer has not given consent for these data to be displayed!',
            burimi: 'Source: Tax Administration of Kosovo (TAK).',
            pasqyratTitulli: 'Financial statements',
            pasqyratPershkrim: 'Select the year and the form to get the financial statement declared to TAK.',
            viti: 'Year',
            formulari: 'Form',
            kerko: 'Search',
            shkarko: 'Download Excel',
            pasqyraBosh: 'No financial statement has been declared for the selected year and form.',
            pasqyraGabim: 'The financial statement could not be retrieved from TAK. Please try again.',
            sesioniSkadoi: 'The session has expired. Refresh the page and try again.',
            shumeKerkesa: 'Too many requests. Please try again later.',
            formularet: {
                Fs100: 'Statement of financial position as at 31 December (Balance Sheet)',
                Fs110: 'Statement of comprehensive income for the year ended 31 December (Income Statement)',
                Fs120: 'Statement of changes in equity for the year ended 31 December',
                Fs130: 'Statement of cash flows for the year ended 31 December',
                Fs150: 'Consolidated statement of financial position as at 31 December',
                Fs160: 'Consolidated statement of comprehensive income and retained earnings',
                Fs170: 'Consolidated statement of changes in equity',
                Fs180: 'Consolidated statement of cash flows',
            },
        },
    },
    sr: {
        form: {
            title: 'Pretraga biznisa',
            subtitle: 'Popunite polja za filtriranje rezultata',
            resetTooltip: 'Resetuj formular pretrage',
            advancedToggle: 'Napredna pretraga',
            submit: 'PRETRAGA',
            emriBiznesit: 'Naziv',
            emriBiznesitPlaceholder: 'Naziv biznisa ili trgovačko ime',
            nui: 'JMB',
            nuiPlaceholder: 'Jedinstveni matični broj ili broj biznisa',
            nrPersonal: 'ID Vlasnika / Ovlaštenika / Odbora',
            komuna: 'Opština',
            sektori: 'Sektor',
            aktivitetiKryesor: 'Glavna Aktivnost',
            numriFiskal: 'Fiskalni Broj',
            aktivitetetTjera: 'Ostale Aktivnosti',
            ndryshimiTipit: 'Promena oblika poslovanja',
            formaBiznesit: 'Oblik biznisa',
            pronesia: 'Vlasništvo',
            pronesiaLegend: 'Pretraga po podacima o vlasništvu',
            perqindjaHuaj: 'Procenat stranog vlasništva',
            shteti: 'Država',
            komunaPronarit: 'Opština e Vlasnika',
            emerPronari: 'Ime vlasnika / zakonskog vlasnika / predstavnika / odbora',
            mbiemriPronarit: 'Prezime vlasnika / zakonskog vlasnika / predstavnika / odbora',
            statusi: 'Status biznisa',
            numriNjesise: 'Broj jedinice',
            numriNjesiveTeRegjistruara: 'Broj registrovanih jedinica',
            emriVjeter: 'Stari naziv biznisa',
            emriVjeterPlaceholder: 'Prethodni naziv biznisa',
            email: 'Email',
            emailPlaceholder: 'Email biznisa',
            telefoni: 'Telefon',
            telefoniPlaceholder: 'Broj telefona',
            adresa: 'Adresa / Ulica',
            adresaPlaceholder: 'Adresa ili ulica',
            vitiThemelimit: 'Godina osnivanja',
            vitiShuarjes: 'Godina zatvaranja',
            vitiNdryshimit: 'Godina poslednje promene',
            yearPlaceholder: 'Izaberite godinu...',
            kontaktiLegend: 'Pretraga po podacima o kontaktu i adresi',
            pronariLegend: 'Pretraga po podacima o vlasnicima, direktorima, ovlaštenim licima i članovima odbora',
            numriPuntoreve: 'Broj zaposlenih',
            numriPuntorevePlaceholder: 'Broj zaposlenih',
            institucioni: 'Institucija',
            institucioniPlaceholder: 'Izaberite instituciju',
            vitetLegend: 'Pretraga po podacima o godini',
            teDhenatShteseLegend: 'Pretraga po dodatnim podacima o biznisu',
            selectPlaceholder: 'Izaberite...',
            validationError: 'Molimo popunite najmanje jedno polje',
            networkError: 'Greška mreže ili servera. Pokušajte ponovo.',
            verificationLoading: 'Verifikacija se učitava. Pokušajte ponovo.',
            verificationFailed: 'Verifikacija nije uspela. Pokušajte ponovo.',
            verificationRetry: 'Pokušajte ponovo',
            tooManyRequests: 'Previše pretraga. Pokušajte kasnije.',
            detailsDailyLimit:
                'Dostigli ste maksimalan broj biznisa koje možete pregledati u roku od 24 sata. Pokušajte ponovo kasnije.',
            detailsTooManyRequests: 'Otvorili ste previše biznisa za kratko vreme. Pokušajte ponovo za minut.',
            detailsExpired: 'Rezultati pretrage su istekli. Molimo pretražite ponovo.',
            detailsNoneSelected: 'Nijedan biznis nije izabran. Molimo izvršite pretragu.',
            minLengthError: 'Kriterijumi pretrage moraju imati najmanje 3 znaka.',
            resultsTruncated:
                'Pretraga ima previše rezultata. Prikazuje se {kufizuar} od {gjithsej} — suzite kriterijume.',
        },
        results: {
            sectionTitle: 'Poslovni rezultati',
            countBanner: (shown, total) => `Lista u nastavku prikazuje ${shown} od ${total} rezultata vaše pretrage.`,
            refineHint: 'Za preciznije rezultate, dodajte dodatne kriterijume pretrage.',
            empty: 'Nijedan biznis nije pronađen za date kriterijume.',
            columns: {
                emri: 'Ime',
                emriTregtar: 'Trgovačko Ime',
                nui: 'JMB',
                komuna: 'Opština',
                llojiBiznesit: 'Poslovni tip',
                statusi: 'Status',
                njesite: 'Jedinice',
            },
            ndryshimiTipit: 'Promena oblika biznisa',
            groupOwners: 'Vlasnici',
            groupReps: 'Predstavnici',
            groupBordi: 'Odbor',
            groupContact: 'Kontakt',
            email: 'Email',
            sektori: 'Sektor',
            numriPuntoreve: 'Broj zaposlenih',
            noOwners: 'Nema registrovanih vlasnika.',
            noReps: 'Nema registrovanih predstavnika.',
            noBordi: 'Nema registrovanih članova odbora.',
            ownerLegal: 'Pravni vlasnik',
            ownerPhysical: 'Fizički vlasnik',
            showMorePersons: (n) => `+${n} više`,
            showLessPersons: 'Manje',
            statusLabel: 'Status',
            units: (n) => `${n} ${n === 1 ? 'jedinica' : 'jedinice'}`,
            sortLabel: 'Sortiraj po',
            sortRelevance: 'Najbolje podudaranje',
            established: 'Osnovan',
            passive: 'Pasivizovan',
            closed: 'Ugašen',
            rowDetails: 'Pogledaj detalje biznisa',
        },
        atk: {
            tab: 'PAK informacije',
            title: 'Informacije iz PAK',
            subtitle: 'Poreska administracija Kosova',
            empty: 'Podaci iz PAK nisu dostupni.',
            loading: 'Učitavanje podataka iz PAK...',
            error: 'Podaci iz PAK nisu učitani. Pokušajte ponovo.',
            retry: 'Pokušaj ponovo',
            tatimpaguesi: 'Podaci o poreskom obvezniku',
            nui: 'Jedinstveni identifikacioni broj',
            emri: 'Naziv',
            numriPunetoreve: 'Broj zaposlenih',
            numriPunetorevePershkrim: 'Broj zaposlenih prijavljen u poslednjoj deklaraciji u PAK',
            statusi: 'Status',
            dataStatusit: 'Datum statusa',
            adresaTitulli: 'Podaci o adresi',
            adresa: 'Adresa',
            telefoni: 'Telefon',
            email: 'E-mail',
            kontabilisti: 'Podaci o računovođi',
            emriKontabilistit: 'Ime',
            llogariaBankare: 'Podaci o bankovnom računu',
            banka: 'Banka',
            numriLlogarise: 'Broj računa',
            paPelqim: 'Poreski obveznik nije dao saglasnost za prikazivanje ovih podataka!',
            burimi: 'Izvor: Poreska administracija Kosova (PAK).',
            pasqyratTitulli: 'Finansijski izveštaji',
            pasqyratPershkrim: 'Izaberite godinu i obrazac da biste dobili finansijski izveštaj prijavljen u PAK.',
            viti: 'Godina',
            formulari: 'Obrazac',
            kerko: 'Pretraži',
            shkarko: 'Preuzmi Excel',
            pasqyraBosh: 'Za izabranu godinu i obrazac nije prijavljen finansijski izveštaj.',
            pasqyraGabim: 'Finansijski izveštaj nije preuzet iz PAK. Pokušajte ponovo.',
            sesioniSkadoi: 'Sesija je istekla. Osvežite stranicu i pokušajte ponovo.',
            shumeKerkesa: 'Previše zahteva. Pokušajte kasnije.',
            formularet: {
                Fs100: 'Izveštaj o finansijskom položaju na dan 31. decembra (Bilans stanja)',
                Fs110: 'Izveštaj o sveobuhvatnom prihodu za godinu koja se završava 31. decembra (Bilans uspeha)',
                Fs120: 'Izveštaj o promenama na kapitalu za godinu koja se završava 31. decembra',
                Fs130: 'Izveštaj o tokovima gotovine za godinu koja se završava 31. decembra',
                Fs150: 'Konsolidovani izveštaj o finansijskom položaju na dan 31. decembra',
                Fs160: 'Konsolidovani izveštaj o sveobuhvatnom prihodu i zadržanoj dobiti',
                Fs170: 'Konsolidovani izveštaj o promenama na kapitalu',
                Fs180: 'Konsolidovani izveštaj o tokovima gotovine',
            },
        },
    },
};

export default function getLabels(locale) {
    return LABELS[locale] || LABELS.sq;
}
